<template>
    <div class="p-4 md:p-6 flex-1 overflow-y-auto font-sans">
		<!-- ── Section Header ── -->
		<div class="flex items-center justify-between mb-6 pb-5 border-b border-primary-100 dark:border-dark-600">
			<div class="flex items-center gap-3">
				<div
					class="w-10 h-10 rounded-xl bg-primary-50 dark:bg-primary-400/15 flex items-center justify-center flex-shrink-0">
					<svg class="w-5 h-5 text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
							d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
					</svg>
				</div>
				<div>
					<h1
						class="font-display text-xl md:text-2xl font-extrabold tracking-tight text-dark-700 dark:text-white">
						Event Management
					</h1>
					<p class="text-[13px] text-muted dark:text-muted-light mt-0.5">
						All your events in one place
					</p>
				</div>
			</div>
		</div>

		<Breadcrumbs />

        <!-- Content -->
        <div
            class="bg-surface dark:bg-dark-700 rounded-card shadow-card border border-primary-100 dark:border-dark-600 p-6 transition-colors duration-300">
            <AttendeeList />
        </div>
    </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import AttendeeList from "@/components/AttendeeList.vue";
export default {
	components: {  Breadcrumbs, AttendeeList },
}
</script>